import {ProcessadorTexto} from './ProcessadorTexto';

export class ProcessadorTransacoesCaixaTexto extends ProcessadorTexto {
  private formateData(valor: any) {
    if(!valor)
      return '-';

    const data = new Date(valor);

    if(isNaN(data.getTime()))
      return '-';

    return data.toLocaleString('pt-BR').split(',').join('');
  }

  private formateValor(valor: any) {
    if(valor === null || valor === undefined || valor === '' || isNaN(Number(valor)))
      return '-';

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(Number(valor)).replace(/[\u00a0\u202f]/g, ' ');
  }

  private linhasDoTexto(texto: any) {
    const valor = String(texto === null || texto === undefined || texto === '' ? '-' : texto)
      .replace(/\s+/g, ' ')
      .trim();

    return this.multiplasLinhas(valor || '-', this.papel.tamanhoLinha, false)
      .map((linha: string) => this.linha(linha.trim()))
      .join('');
  }

  private linhasCentralizadas(texto: any) {
    const valor = String(texto || '-')
      .replace(/\s+/g, ' ')
      .trim();

    return this.multiplasLinhas(valor || '-', this.papel.tamanhoLinha, false)
      .map((linha: string) => this.centralizarLinha(linha.trim()))
      .join('');
  }

  private rotuloTipo(tipo: string) {
    if(tipo === 'ENTRADA')
      return 'ENTRADA';

    if(tipo === 'SAIDA')
      return 'SAÍDA';

    if(tipo === 'VENDA_FIADA')
      return 'FIADO';

    return tipo || '-';
  }

  private obtenhaReferencia(transacao: any) {
    if(transacao?.pedido?.id) {
      const codigo = transacao.pedido.codigo !== null && transacao.pedido.codigo !== undefined
        ? transacao.pedido.codigo
        : transacao.pedido.id;
      return `Pedido: #${codigo}`;
    }

    if(transacao?.comanda?.id) {
      const mesa = transacao?.comanda?.mesa?.nome;
      return `Comanda: #${transacao.comanda.id}${mesa ? ' - ' + mesa : ''}`;
    }

    return 'Pedido/Comanda: -';
  }

  private some(transacoes: any[], tipo: string) {
    return transacoes
      .filter((transacao: any) => transacao?.tipo === tipo)
      .reduce((total: number, transacao: any) => total + (Number(transacao?.valor) || 0), 0);
  }

  obtenhaRelatorio(caixa: any) {
    const transacoes = (caixa?.transacoes || []).slice().sort((a: any, b: any) => {
      const horarioA = new Date(a?.data).getTime();
      const horarioB = new Date(b?.data).getTime();
      const valorA = isNaN(horarioA) ? Number.MAX_SAFE_INTEGER : horarioA;
      const valorB = isNaN(horarioB) ? Number.MAX_SAFE_INTEGER : horarioB;
      return valorA - valorB;
    });

    let relatorio = this.linhasCentralizadas(caixa?.empresa?.nome || '-');
    relatorio += this.centralizarLinha('TRANSAÇÕES DO CAIXA');
    relatorio += this.linhaComCaracter('-');
    relatorio += this.linhasDoTexto(`Caixa: #${caixa?.id || '-'}`);
    relatorio += this.linhasDoTexto(`Status: ${caixa?.status || '-'}`);
    relatorio += this.linhasDoTexto(`Operador abertura: ${caixa?.operador?.nome || (caixa?.online ? 'Online' : '-')}`);
    relatorio += this.linhasDoTexto(`Abertura: ${this.formateData(caixa?.horarioAbertura)}`);

    if(caixa?.horarioFechamento)
      relatorio += this.linhasDoTexto(`Fechamento: ${this.formateData(caixa.horarioFechamento)}`);

    relatorio += this.linhasDoTexto(`Impresso em: ${this.formateData(caixa?.horaImpressao || new Date())}`);
    relatorio += this.linhasDoTexto(`Quantidade: ${transacoes.length}`);
    relatorio += this.linhaComCaracter('=');

    transacoes.forEach((transacao: any) => {
      relatorio += this.linhasDoTexto(`Data: ${this.formateData(transacao?.data)}`);
      relatorio += this.linhasDoTexto(`Tipo: ${this.rotuloTipo(transacao?.tipo)}`);
      relatorio += this.linhasDoTexto(`Valor: ${this.formateValor(transacao?.valor)}`);
      relatorio += this.linhasDoTexto(`Descrição: ${transacao?.descricao || '-'}`);
      relatorio += this.linhasDoTexto(`Pagamento: ${transacao?.formaDePagamento?.descricao || transacao?.formaDePagamento?.nome || '-'}`);
      relatorio += this.linhasDoTexto(`Operador: ${transacao?.operador?.nome || '-'}`);
      relatorio += this.linhasDoTexto(this.obtenhaReferencia(transacao));
      relatorio += this.linhaComCaracter('-');
    });

    relatorio += this.centralizarLinha('RESUMO');
    relatorio += this.linhasDoTexto(`Entradas: ${this.formateValor(this.some(transacoes, 'ENTRADA'))}`);
    relatorio += this.linhasDoTexto(`Saídas: ${this.formateValor(this.some(transacoes, 'SAIDA'))}`);
    relatorio += this.linhasDoTexto(`Fiado: ${this.formateValor(this.some(transacoes, 'VENDA_FIADA'))}`);
    relatorio += this.linha();

    return relatorio;
  }
}
